import theme from 'shared/theme';
import styled from 'styled-components';

export const UL = styled.ul``;

export const OL = styled.ol``;

export const LI = styled.li`
  font-family: Lato !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43 !important;
  letter-spacing: normal;
  text-align: left;
  color: ${theme.community.stone} !important;
`;
